import { createTheme } from '@material-ui/core/styles';

const basicTheme = createTheme({
    typography: {
        button: {
            textTransform: 'none',
        },
        fontFamily: 'Lato !important',
    },

    palette: {
        primary: {
            main: '#000',
            contrastText: '#fff',
        },

        secondary: {
            main: '#B49759',
            contrastText: '#fff',
        },
    },
});

export default basicTheme;
